export const version = "networks/5.6.3";
//# sourceMappingURL=_version.js.map